<template>
  <div class="waitLease-group-dashboard-sentableCars" v-loading="loading">
    <AlertBox
      class="mb16"
      title="可发车辆概览、可发车辆在库时长TOP20车辆为准实时数据，数据更新可能会存在一小时左右的延迟"
      btnText="刷新数据"
      @btnClick="update"
    />

    <FiltersBox
      class="mb16"
      :filterList="globalFilter.filterList"
      :model.sync="globalFilter.model"
      @change="handleGlobalFiltersChange"
    />

    <!-- 可发车辆概览 -->
    <HorizontalCardStyle3
      class="mb16"
      :title="toLeaseOverviewData.title"
      :dataDesc="toLeaseOverviewData.dataDesc"
      :dataUpdateTime="dataUpdateTime"
      :primaryDataList="toLeaseOverviewData.primaryDataList"
      :secondaryDataList="toLeaseOverviewData.secondaryDataList"
    />

    <el-row class="mb16" :gutter="16">
      <el-col :span="12">
        <!-- 可发已备车 -->
        <HorizontalCardStyle1
          :title="readyLeaseNumData.title"
          :dataDesc="readyLeaseNumData.dataDesc"
          :dataUpdateTime="dataUpdateTime"
          :primaryDataList="readyLeaseNumData.primaryDataList"
          :secondaryDataList="readyLeaseNumData.secondaryDataList"
        />
      </el-col>
      <el-col :span="12">
        <!-- 个人订单锁定未发车 -->
        <HorizontalCardStyle1
          :title="personOrderLockNumData.title"
          :dataDesc="personOrderLockNumData.dataDesc"
          :dataUpdateTime="personOrderLockNumData.dataUpdateTime"
          :primaryDataList="personOrderLockNumData.primaryDataList"
          :secondaryDataList="personOrderLockNumData.secondaryDataList"
        />
      </el-col>
    </el-row>

    <el-row class="mb16" :gutter="16">
      <el-col :span="12">
        <!-- 企业子订单订单锁定未发车 -->
        <HorizontalCardStyle1
          :title="entOrderLockNumData.title"
          :dataDesc="entOrderLockNumData.dataDesc"
          :dataUpdateTime="entOrderLockNumData.dataUpdateTime"
          :primaryDataList="entOrderLockNumData.primaryDataList"
          :secondaryDataList="entOrderLockNumData.secondaryDataList"
        />
      </el-col>
    </el-row>

    <el-row class="mb16">
      <el-col :span="24">
        <FiltersBox
          :filterList="chartFilter.filterList"
          :model.sync="chartFilter.model"
          @change="handleChartFiltersChange"
        />
      </el-col>
    </el-row>

    <el-row class="mb16" :gutter="16">
      <el-col :span="12">
        <!-- 可发车数量（折线图） -->
        <LineChartCard
          class="chart"
          :title="toLeaseNumChartData.title"
          :tooltip="toLeaseNumChartData.tooltip"
          :dataDesc="toLeaseNumChartData.dataDesc"
          :dataUpdateTime="toLeaseNumChartData.dataUpdateTime"
          :xAxis="toLeaseNumChartData.xAxis"
          :yAxis="toLeaseNumChartData.yAxis"
          :legendData="toLeaseNumChartData.legendData"
          :seriesData="toLeaseNumChartData.seriesData"
          :unit="toLeaseNumChartData.unit"
        />
      </el-col>
      <el-col :span="12">
        <!-- 可发车平均在库时长（折线图） -->
        <LineChartCard
          class="chart"
          :title="avgInStockDayChartData.title"
          :tooltip="avgInStockDayChartData.tooltip"
          :dataDesc="avgInStockDayChartData.dataDesc"
          :dataUpdateTime="avgInStockDayChartData.dataUpdateTime"
          :xAxis="avgInStockDayChartData.xAxis"
          :yAxis="avgInStockDayChartData.yAxis"
          :legendData="avgInStockDayChartData.legendData"
          :seriesData="avgInStockDayChartData.seriesData"
          :unit="avgInStockDayChartData.unit"
        />
      </el-col>
    </el-row>

    <el-row class="mb16" :gutter="16">
      <el-col :span="12">
        <!-- 保险利用率（折线图） -->
        <LineChartCard
          class="chart"
          :title="insuranceUsedRateChartData.title"
          :tooltip="insuranceUsedRateChartData.tooltip"
          :dataDesc="insuranceUsedRateChartData.dataDesc"
          :dataUpdateTime="insuranceUsedRateChartData.dataUpdateTime"
          :xAxis="insuranceUsedRateChartData.xAxis"
          :yAxis="insuranceUsedRateChartData.yAxis"
          :legendData="insuranceUsedRateChartData.legendData"
          :seriesData="insuranceUsedRateChartData.seriesData"
          :unit="insuranceUsedRateChartData.unit"
        />
      </el-col>
    </el-row>

    <!-- 可发车辆在库时长top20车辆 -->
    <RankingListCardStyle1
      :title="inStockDayTopData.title"
      :tooltip="inStockDayTopData.tooltip"
      :dataDesc="inStockDayTopData.dataDesc"
      :dataUpdateTime="inStockDayTopData.dataUpdateTime"
      :filterList="inStockDayTopData.filterList"
      :filterModel="inStockDayTopData.filterModel"
      :tableColumns="inStockDayTopData.tableColumns"
      :tableData="inStockDayTopData.tableData"
      @filtersChange="getInStockDayTopData"
    />
  </div>
</template>
<script>
import moment from 'moment'
import AlertBox from '@/bizComponents/Dashboard/alertBox'
import FiltersBox from '@/bizComponents/Dashboard/filtersBox'
import HorizontalCardStyle1 from '@/bizComponents/Dashboard/cards/horizontalCard/style1.vue'
import HorizontalCardStyle3 from '@/bizComponents/Dashboard/cards/horizontalCard/style3.vue'
import LineChartCard from '@/bizComponents/Dashboard/cards/lineChartCard'
import RankingListCardStyle1 from '@/bizComponents/Dashboard/cards/rankingListCard/style1.vue'
import { getYAxisNumMax, getYAxisNumMin, getYAxisPercentMin } from '@/bizComponents/Dashboard/utils/function'
import {
  getVehicleHoldInfo,
  getOrderLockCarNum,
  getToLeaseNum,
  getAvgInStockDay,
  getInsuranceUsedRate,
  getSeriesList,
  getInStockDayTop,
} from '@/api/domain/waitLease'
import { useQueryStringify } from '@/utils/useAutoQuery'
import { TABS } from '@/pages/cars/list/config/index'

const formateSeriesOptions = (options) => {
  options.forEach((option) => {
    option.label = option.carSeriesName || option.brandName || ''
    option.value = option.carSeriesId || option.brandId || ''
    if (Array.isArray(option.carSeriesList)) {
      option.children = option.carSeriesList
      formateSeriesOptions(option.children)
    }
  })
  return options
}

export default {
  components: {
    AlertBox,
    FiltersBox,
    HorizontalCardStyle1,
    HorizontalCardStyle3,
    LineChartCard,
    RankingListCardStyle1,
  },
  provide() {
    return {
      ratioConfig: this.globalFilter.model,
    }
  },
  data() {
    return {
      // 全局筛选
      globalFilter: {
        filterList: [
          {
            type: 'DeptSelect',
            label: '所属部门',
            name: 'deptId',
            options: [],
          },
          {
            type: 'select',
            label: '环比/同比',
            name: 'showRatio',
            options: [
              {
                label: '展示',
                value: true,
              },
              {
                label: '不展示',
                value: false,
              },
            ],
          },
        ],
        model: {
          deptId: this.$store.getters.userInfo.deptId || '',
          showRatio: true,
        },
      },
      // 局部筛选
      chartFilter: {
        filterList: [
          {
            type: 'dateRange',
            label: '时间',
            name: 'date',
            t_1: true,
            // 结束日期不可>当前日期，时间范围不可大于1年
            pickerOptions: {
              tipConfig: {
                type: 1,
                daysNum: 365,
              },
              disabledDate: (time) => {
                return time.getTime() >= new Date(moment().format('YYYY-MM-DD 00:00:00')).getTime()
              },
            },
          },
          {
            type: 'select',
            label: '视角',
            name: 'type',
            options: [
              {
                label: '部门',
                value: 1,
              },
              {
                label: '车型',
                value: 2,
              },
            ],
          },
        ],
        model: {
          // 默认最近30天
          date: [
            moment(moment(Date.now() - 24 * 60 * 60 * 1000 - (30 * 24 * 60 * 60 * 1000))).format('YYYY-MM-DD HH:mm:ss'),
            moment(moment(Date.now() - 24 * 60 * 60 * 1000)).format('YYYY-MM-DD HH:mm:ss'),
          ],
          type: 1,
        },
      },
      // 数据更新时间
      dataUpdateTime: '',
      // 可发车辆概览
      toLeaseOverviewData: {
        title: '可发车辆概览',
        dataDesc: '实时数据',
        primaryDataList: [],
        secondaryDataList: [],
      },
      // 可发已备车
      readyLeaseNumData: {
        title: '可发已备车',
        dataDesc: '实时数据',
        primaryDataList: [],
        secondaryDataList: [],
      },
      // 个人订单锁定未发车
      personOrderLockNumData: {
        title: '个人订单锁定未发车',
        dataDesc: '实时数据',
        dataUpdateTime: '',
        primaryDataList: [],
        secondaryDataList: [],
      },
      // 企业子订单订单锁定未发车
      entOrderLockNumData: {
        title: '企业子订单订单锁定未发车',
        dataDesc: '实时数据',
        dataUpdateTime: '',
        primaryDataList: [],
        secondaryDataList: [],
      },
      // 可发车数量-图表
      toLeaseNumChartData: {
        title: '可发车数量',
        tooltip: '每日累计的可发车数量',
        dataDesc: 'T-1日数据',
        dataUpdateTime: '',
        xAxis: {
          data: [],
        },
        yAxis: {
          axisLabel: {
            show: true,
            interval: 'auto',
          },
          max: (value) => getYAxisNumMax(value, 5),
          min: (value) => getYAxisNumMin(value, 5),
        },
        legendData: [],
        seriesData: [],
      },
      // 可发车平均在库时长-图表
      avgInStockDayChartData: {
        title: '可发车平均在库时长',
        tooltip: '日平均在库时长=∑（单车当日车辆在库时长）/可发车量数',
        dataDesc: 'T-1日数据',
        dataUpdateTime: '',
        xAxis: {
          data: [],
        },
        yAxis: {
          axisLabel: {
            show: true,
            interval: 'auto',
            formatter: '{value}天',
          },
          max: (value) => getYAxisNumMax(value, 5),
          min: (value) => getYAxisNumMin(value, 5),
        },
        legendData: [],
        seriesData: [],
        unit: '天',
      },
      // 保险利用率-图表
      insuranceUsedRateChartData: {
        title: '保险利用率',
        tooltip: '保险利用率=在租车辆投保商业险数量/可运营车辆投保商业险数量*100% *可运营车辆包含待入库、待处理、待租、已租 车辆',
        dataDesc: 'T-1日数据',
        dataUpdateTime: '',
        xAxis: {
          data: [],
        },
        yAxis: {
          axisLabel: {
            show: true,
            interval: 'auto',
            formatter: '{value}%',
          },
          max: 100,
          min: (value) => getYAxisPercentMin(value, 10),
        },
        legendData: [],
        seriesData: [],
        unit: '%',
      },
      // 可发车辆在库时长top20车辆
      inStockDayTopData: {
        title: '可发车辆在库时长top20车辆',
        tooltip: '车辆最新一次在库未租的时长',
        dataDesc: '实时数据',
        dataUpdateTime: '',
        filterList: [
          {
            type: 'cascader',
            label: '车系',
            name: 'seriesId',
            options: [],
          },
        ],
        filterModel: {
          seriesId: '',
        },
        tableColumns: [
          {
            name: 'id',
            columnProps: {
              label: '排序',
              prop: 'id',
            },
          },
          {
            name: 'plateNo',
            columnProps: {
              label: '车牌号',
              prop: 'plateNo',
              width: 100,
            },
            getText: ({ row }) => row.plateNo || '--',
            getHref: ({ row }) => {
              const query = {
                b: TABS.WaitForRent,
                f: {
                  id: row.carId,
                },
              }
              // 跳转“车辆-车辆列表-待租”，将车牌号转换为ID进行数据检索 https://devops.aliyun.com/projex/bug/PKXW-11346# 《【线上问题】点击车辆租赁订单绑定记录，点击列表中的车牌号跳转绑带的车牌号错误》
              return `/vehicle/vehicleManage/list?${useQueryStringify(query)}`
            },
            type: 'link',
            target: '_blank',
          },
          {
            name: 'brand',
            columnProps: {
              label: '品牌',
              prop: 'brand',
            },
          },
          {
            name: 'carSeries',
            columnProps: {
              label: '车系',
              prop: 'carSeries',
            },
          },
          {
            name: 'inStockDay',
            columnProps: {
              label: '在库时长',
              prop: 'inStockDay',
            },
            render: ({ row }) => `${row.inStockDay}天`,
          },
          {
            name: 'deptName',
            columnProps: {
              label: '所属部门',
              prop: 'deptName',
            },
          },
        ],
        tableData: [],
      },
      loading: false,
    }
  },
  computed: {
    deptId() {
      return this.$store.getters.userInfo.deptId
    },
    params() {
      const { date } = this.chartFilter.model
      const startDate = Array.isArray(date) ? moment(date[0]).format('YYYY-MM-DD') : ''
      const endDate = Array.isArray(date) ? moment(date[1]).format('YYYY-MM-DD') : ''
      return {
        deptIdList: this.globalFilter.model.deptId ? [this.globalFilter.model.deptId] : [],
        type: this.chartFilter.model.type,
        seriesId: this.inStockDayTopData.filterModel.seriesId || '',
        startDate,
        endDate,
      }
    },
    // 根部门ID
    rootDeptId() {
      return this.$store.getters.userInfo.rootDeptId
    },
    // 部门路由参数
    routerDeptId() {
      const selectDeptId = this.globalFilter.model.deptId
      return selectDeptId === this.rootDeptId ? '' : selectDeptId
    },
  },
  watch: {
    deptId: {
      handler(val) {
        if (val) {
          this.globalFilter.model.deptId = val || ''
        }
      },
      deep: true,
      immediate: true,
    },
  },
  created() {
    this.getSeriesList()
    this.update()
  },
  methods: {
    update() {
      this.loading = true
      Promise.all([
        this.getToLeaseNumOverview(),
        this.getOrderLockCarNumData(),
        this.getToLeaseNumChart(),
        this.getAvgInStockDayChart(),
        this.getInsuranceUsedRateChart(),
        this.getInStockDayTopData(),
      ]).finally(() => {
        this.loading = false
      })
    },
    handleGlobalFiltersChange() {
      this.update()
    },
    handleChartFiltersChange() {
      this.loading = true
      Promise.all([
        this.getToLeaseNumChart(),
        this.getAvgInStockDayChart(),
        this.getInsuranceUsedRateChart(),
      ]).finally(() => {
        this.loading = false
      })
    },
    // 跳转车辆-车辆列表
    toVehicleManageList({ tab, tagId, plateNo }) {
      const query = {
        b: '',
        f: {
          deptIdList: this.routerDeptId ? [this.routerDeptId] : [],
        },
      }
      // tab '0':全部车辆 '5':待入库 '10':待处理 '20':待租 '40':已租 'outCar':退出运营
      if (typeof tab !== 'undefined') {
        query.b = String(tab)
      }
      // 车辆标签
      if (typeof tagId !== 'undefined') {
        query.f.tagId = tagId
      }
      // 车牌号
      if (typeof plateNo !== 'undefined') {
        query.f.plateNo = plateNo
      }
      this.$router.push(`/vehicle/vehicleManage/list?${useQueryStringify(query)}`)
    },
    // 跳转签约提车
    toSignContract({ activeName, childActiveName }) {
      const query = {
        deptId: this.routerDeptId,
      }

      // 一级tab
      if (typeof activeName !== 'undefined') {
        query.activeName = activeName
      }
      // 二级tab
      if (typeof childActiveName !== 'undefined') {
        query.childActiveName = childActiveName
      }

      this.$router.push({
        path: '/car_to_lease/forRentSignContract',
        query,
      })
    },
    // 获取可发车辆概览
    async getToLeaseNumOverview() {
      const res = await getVehicleHoldInfo(this.params)
      const { code, data } = res

      if (code === 1 && data) {
        this.dataUpdateTime = data.updateTime || ''
        // 可发车辆概览
        this.toLeaseOverviewData.primaryDataList = [
          {
            label: '当前累计可发数量',
            value: data?.toLease?.totalNumber || 0,
            unit: '辆',
            tooltip: '当前累计可发车辆数量',
            // 跳转车辆-车辆列表-待租车辆
            clickCallback: () => this.toVehicleManageList({
              tab: TABS.WaitForRent,
            }),
          },
        ]
        this.toLeaseOverviewData.secondaryDataList = [
          {
            label: '今日新增可发',
            value: data?.toLease?.todayNumber || 0,
            unit: '辆',
            tooltip: '今日新增经历过可发的车辆数量',
            ratioList: [
              {
                name: '日环比',
                value: data?.toLease?.todayNumberDayRadio,
              },
              {
                name: '周同比',
                value: data?.toLease?.todayNumberWeekYoY,
              },
            ],
          },
          {
            label: '今日可发转已租',
            value: data?.leased?.todayNumber || 0,
            unit: '辆',
            tooltip: '今日经历过可发转已租的车辆数量',
            ratioList: [
              {
                name: '日环比',
                value: data?.leased?.todayNumberDayRadio,
              },
              {
                name: '周同比',
                value: data?.leased?.todayNumberWeekYoY,
              },
            ],
          },
          {
            label: '昨日新增可发',
            value: data?.toLease?.yesterdayNumber || 0,
            unit: '辆',
            tooltip: '昨日新增经历过可发的车辆数量',
            ratioList: [
              {
                name: '日环比',
                value: data?.toLease?.yesterdayNumberDayRadio,
              },
              {
                name: '周同比',
                value: data?.toLease?.yesterdayNumberWeekYoY,
              },
            ],
          },
          {
            label: '昨日可发转已租',
            value: data?.leased?.yesterdayNumber || 0,
            unit: '辆',
            tooltip: '昨日经历过可发转已租的车辆数量',
            ratioList: [
              {
                name: '日环比',
                value: data?.leased?.yesterdayNumberDayRadio,
              },
              {
                name: '周同比',
                value: data?.leased?.yesterdayNumberWeekYoY,
              },
            ],
          },
          {
            label: '本周新增可发',
            value: data?.toLease?.weekNumber || 0,
            unit: '辆',
            tooltip: '本周时间范围内，新增经历过可发的车辆数量',
            ratioList: [
              {
                name: '周环比',
                value: data?.toLease?.weekNumberRadio,
              },
            ],
          },
          {
            label: '本周可发转已租',
            value: data?.leased?.weekNumber || 0,
            unit: '辆',
            tooltip: '本周时间范围内，经历过可发转已租的车辆数量',
            ratioList: [
              {
                name: '周环比',
                value: data?.leased?.weekNumberRadio,
              },
            ],
          },
          {
            label: '本月新增可发',
            value: data?.toLease?.monthNumber || 0,
            unit: '辆',
            tooltip: '本月时间范围内，新增经历过可发的车辆数量',
            ratioList: [
              {
                name: '月环比',
                value: data?.toLease?.monthNumberRadio,
              },
            ],
          },
          {
            label: '本月可发转已租',
            value: data?.leased?.monthNumber || 0,
            unit: '辆',
            tooltip: '本月时间范围内，经历过可发转已租的车辆数量',
            ratioList: [
              {
                name: '月环比',
                value: data?.leased?.monthNumberRadio,
              },
            ],
          },
        ]

        // 可发已备车
        this.readyLeaseNumData.primaryDataList = [
          {
            label: '累计可发已备车',
            value: data?.readyLease?.totalNumber || 0,
            unit: '辆',
            tooltip: '当前累计可发已备车数量',
            // 跳转至“车辆-车辆列表-待租车辆”，筛选条件中，车辆标签带入“已备车”
            clickCallback: () => this.toVehicleManageList({
              tab: TABS.WaitForRent,
              tagId: 1101,
            }),
          },
        ]
        this.readyLeaseNumData.secondaryDataList = [
          {
            label: '今日备车',
            value: data?.readyLease?.todayNumber || 0,
            unit: '辆',
            tooltip: '今日标记过备车的车辆数量',
            ratioList: [
              {
                name: '日环比',
                value: data?.readyLease?.todayNumberDayRadio,
              },
              {
                name: '周同比',
                value: data?.readyLease?.todayNumberWeekYoY,
              },
            ],
          },
          {
            label: '本周备车',
            value: data?.readyLease?.weekNumber || 0,
            unit: '辆',
            tooltip: '本周标记过备车的车辆数量',
            ratioList: [
              {
                name: '周环比',
                value: data?.readyLease?.weekNumberRadio,
              },
            ],
          },
          {
            label: '本月备车',
            value: data?.readyLease?.monthNumber || 0,
            unit: '辆',
            tooltip: '本月标记过备车的车辆数量',
            ratioList: [
              {
                name: '月环比',
                value: data?.readyLease?.monthNumberRadio,
              },
            ],
          },
        ]
      }
    },
    // 获取订单锁定车辆图标（个人订单、企业子订单）
    async getOrderLockCarNumData() {
      const res = await getOrderLockCarNum(this.params)
      const { code, data } = res

      if (code === 1 && data) {
        // 个人订单锁定未发车
        this.personOrderLockNumData.dataUpdateTime = data.updateTime || ''
        this.personOrderLockNumData.primaryDataList = [
          {
            label: '累计锁定未发车',
            value: data.personOrderAllNum || 0,
            tooltip: '当前累计已创建个人订单未发车的车辆数量',
            unit: '辆',
            // 跳转“签约提车-个人租赁订单-待履约-全部”
            clickCallback: () => this.toSignContract({
              activeName: 'personal',
              childActiveName: '1',
            }),
          },
        ]
        this.personOrderLockNumData.secondaryDataList = [
          {
            label: '订单待确认数',
            value: data.personOrderToConfirmNum || 0,
            tooltip: '当前累计个人订单处于待签署合同状态的车辆数量',
            unit: '辆',
            // 跳转“签约提车-个人租赁订单-待履约-订单待确认”
            clickCallback: () => this.toSignContract({
              activeName: 'personal',
              childActiveName: '11',
            }),
          },
          {
            label: '订单待支付数',
            value: data.personOrderToPayNum || 0,
            tooltip: '当前累计个人订单处于待支付发车前收款项状态的车辆数量',
            unit: '辆',
            // 跳转“签约提车-个人租赁订单-待履约-订单待支付”
            clickCallback: () => this.toSignContract({
              activeName: 'personal',
              childActiveName: '13',
            }),
          },
          {
            label: '订单待发车数',
            value: data.personOrderToOutNum || 0,
            tooltip: '当前累计个人订单处于待发车验车状态的车辆数量',
            unit: '辆',
            // 跳转“签约提车-个人租赁订单-待履约-发车待验车”
            clickCallback: () => this.toSignContract({
              activeName: 'personal',
              childActiveName: '12',
            }),
          },
        ]

        // 企业子订单订单锁定未发车
        this.entOrderLockNumData.dataUpdateTime = data.updateTime || ''
        this.entOrderLockNumData.primaryDataList = [
          {
            label: '累计锁定未发车',
            value: data.entOrderAllNum || 0,
            tooltip: '当前累计已创建企业子订单未发车的车辆数量',
            unit: '辆',
            // 跳转“签约提车-企业租赁子订单-待履约-全部”
            clickCallback: () => this.toSignContract({
              activeName: 'child',
              childActiveName: '1',
            }),
          },
        ]
        this.entOrderLockNumData.secondaryDataList = [
          {
            label: '订单待支付数',
            value: data.entOrderToPayNum || 0,
            tooltip: '当前累计企业子订单处于待支付发车前收款项状态的车辆数量',
            unit: '辆',
            // 跳转“签约提车-企业租赁子订单-待履约-订单待支付”
            clickCallback: () => this.toSignContract({
              activeName: 'child',
              childActiveName: '13',
            }),
          },
          {
            label: '订单待发车数',
            value: data.entOrderToOutNum || 0,
            tooltip: '当前累计企业子订单处于待发车验车状态的车辆数量',
            unit: '辆',
            // 跳转“签约提车-企业租赁子订单-待履约-发车待验车”
            clickCallback: () => this.toSignContract({
              activeName: 'child',
              childActiveName: '12',
            }),
          },
        ]
      }
    },
    // 获取可发车数量图表
    async getToLeaseNumChart() {
      const res = await getToLeaseNum(this.params)
      const { code, data } = res

      if (code === 1 && data) {
        const dataList = data.dataList || []
        this.toLeaseNumChartData.dataUpdateTime = data.updateTime || ''
        // 图例（公司名称 或 车型名称）
        this.toLeaseNumChartData.legendData = data.nameList || []
        this.toLeaseNumChartData.xAxis.data = dataList.map((item) => item.ds) || []
        // 是否公司视角
        const isCompanyView = this.chartFilter.model.type === 1
        // 系列（公司列表 或 车辆列表）
        this.toLeaseNumChartData.seriesData = this.toLeaseNumChartData.legendData.map((item) => {
          return {
            // 系列名称: 公司名称 或 车型名称
            name: item,
            data: dataList.map((itm) => {
              const deptInfo = (itm.deptList || []).find((dept) => dept.deptName === item)
              const seriesInfoItem = (itm.seriesList || []).find((seriesInfo) => seriesInfo.modelName === item)
              // X轴数据（日期）
              const date = itm.ds
              // Y轴数据（比率）: 公司的 或 车型的
              const value = (isCompanyView ? deptInfo?.num : seriesInfoItem?.num) || 0
              // 数据名称
              const dataTitle = this.toLeaseNumChartData.title
              // 环比/同比: 公司的 或 车型的
              const dayRadio = (isCompanyView ? deptInfo?.dayRadio : seriesInfoItem?.dayRadio) || 0
              const weekRadio = (isCompanyView ? deptInfo?.weekYoY : seriesInfoItem?.weekYoY) || 0
              return [
                date,
                value,
                {
                  dataTitle,
                  ratioList: [
                    {
                      name: '日环比',
                      value: dayRadio,
                    },
                    {
                      name: '周同比',
                      value: weekRadio,
                    },
                  ],
                },
              ]
            }),
          }
        })
      }
    },
    // 获取可发车平均在库时长图表
    async getAvgInStockDayChart() {
      const res = await getAvgInStockDay(this.params)
      const { code, data } = res

      if (code === 1 && data) {
        const dataList = data.dataList || []
        this.avgInStockDayChartData.dataUpdateTime = data.updateTime || ''
        // 图例（公司名称 或 车型名称）
        this.avgInStockDayChartData.legendData = data.nameList || []
        this.avgInStockDayChartData.xAxis.data = dataList.map((item) => item.ds) || []
        // 是否公司视角
        const isCompanyView = this.chartFilter.model.type === 1
        // 系列（公司列表 或 车辆列表）
        this.avgInStockDayChartData.seriesData = this.avgInStockDayChartData.legendData.map((item) => {
          return {
            // 系列名称: 公司名称 或 车型名称
            name: item,
            data: dataList.map((itm) => {
              const deptInfo = (itm.deptList || []).find((dept) => dept.deptName === item)
              const seriesInfoItem = (itm.seriesList || []).find((seriesInfo) => seriesInfo.modelName === item)
              // X轴数据（日期）
              const date = itm.ds
              // Y轴数据（比率）: 公司的 或 车型的
              const value = (((isCompanyView ? deptInfo?.rate : seriesInfoItem?.rate) || 0)).toFixed(2)
              // 数据名称
              const dataTitle = this.avgInStockDayChartData.title
              // 环比/同比: 公司的 或 车型的
              const dayRadio = (isCompanyView ? deptInfo?.dayRadio : seriesInfoItem?.dayRadio) || 0
              const weekRadio = (isCompanyView ? deptInfo?.weekYoY : seriesInfoItem?.weekYoY) || 0
              return [
                date,
                value,
                {
                  dataTitle,
                  ratioList: [
                    {
                      name: '日环比',
                      value: dayRadio,
                    },
                    {
                      name: '周同比',
                      value: weekRadio,
                    },
                  ],
                },
              ]
            }),
          }
        })
      }
    },
    // 获取保险利用率图表
    async getInsuranceUsedRateChart() {
      const res = await getInsuranceUsedRate(this.params)
      const { code, data } = res

      if (code === 1 && data) {
        const dataList = data.dataList || []
        this.insuranceUsedRateChartData.dataUpdateTime = data.updateTime || ''
        // 图例（公司名称 或 车型名称）
        this.insuranceUsedRateChartData.legendData = data.nameList || []
        this.insuranceUsedRateChartData.xAxis.data = dataList.map((item) => item.ds) || []
        // 是否公司视角
        const isCompanyView = this.chartFilter.model.type === 1
        // 系列（公司列表 或 车辆列表）
        this.insuranceUsedRateChartData.seriesData = this.insuranceUsedRateChartData.legendData.map((item) => {
          return {
            // 系列名称: 公司名称 或 车型名称
            name: item,
            data: dataList.map((itm) => {
              const deptInfo = (itm.deptList || []).find((dept) => dept.deptName === item)
              const seriesInfoItem = (itm.seriesList || []).find((seriesInfo) => seriesInfo.modelName === item)
              // X轴数据（日期）
              const date = itm.ds
              // Y轴数据（比率）: 公司的 或 车型的
              const value = (((isCompanyView ? deptInfo?.rate : seriesInfoItem?.rate) || 0) * 100).toFixed(2)
              // 数据名称
              const dataTitle = this.insuranceUsedRateChartData.title
              // 环比/同比: 公司的 或 车型的
              const dayRadio = (isCompanyView ? deptInfo?.dayRadio : seriesInfoItem?.dayRadio) || 0
              const weekRadio = (isCompanyView ? deptInfo?.weekYoY : seriesInfoItem?.weekYoY) || 0
              return [
                date,
                value,
                {
                  dataTitle,
                  ratioList: [
                    {
                      name: '日环比',
                      value: dayRadio,
                    },
                    {
                      name: '周同比',
                      value: weekRadio,
                    },
                  ],
                },
              ]
            }),
          }
        })
      }
    },
    // 获取全部车型
    async getSeriesList() {
      const res = await getSeriesList(this.params)
      const { code, data } = res

      if (code === 1 && data) {
        const seriesIdFilter = this.inStockDayTopData.filterList.find((item) => item.name === 'seriesId')
        seriesIdFilter.options = formateSeriesOptions(data || [])
      }
    },
    // 获取可发车辆在库时长top20车辆
    async getInStockDayTopData() {
      const res = await getInStockDayTop(this.params)
      const { code, data } = res

      if (code === 1 && data) {
        this.inStockDayTopData.dataUpdateTime = data.updateTime || ''
        this.inStockDayTopData.tableData = data.topCarList || []
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.mb16 {
  margin-bottom: 16px;
}
.mt24 {
  margin-top: 24px;
}
.module-title {
  margin-top: 24px;
  margin-bottom: 16px;
  font-size: 20px;
  font-weight: 600;
  line-height: 22px;
  color: #3D3D3D;
}
</style>
